/**
 * @generated SignedSource<<79defba9fffda26eeda079a271d0c6b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedMobileLinksBlock_itemSearch$data = {
  readonly popularSearchesLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
  };
  readonly " $fragmentType": "SharedMobileLinksBlock_itemSearch";
};
export type SharedMobileLinksBlock_itemSearch$key = {
  readonly " $data"?: SharedMobileLinksBlock_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileLinksBlock_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileLinksBlock_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "21ed6b0010e1e2a4de07a59d1c209103";

export default node;
